import React from 'react';
import { useParams } from 'react-router-dom';
import ProductComponent from './product';
import SEO from '../components/seo';

const Product = () => {
    const { id } = useParams();

  
  
  return (
    <>
      <SEO
        title="Product Details"
        description="View product details and add to cart"
      />
      <ProductComponent id={id} />
    </>
  );
};

export default Product;